export const MapIcon = ({ className, onClick }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_3481_107416)">
        <path
          d="M6.125 11.2812V2.84375"
          stroke="#070707"
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.875 4.71875V13.1562"
          stroke="#070707"
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.125 11.2812L2.375 12.2188V3.78125L6.125 2.84375L9.875 4.71875L13.625 3.78125V12.2188L9.875 13.1562L6.125 11.2812Z"
          stroke="#070707"
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3481_107416">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
